function additiveInverseArray(arr: number[]) {
  return arr.map((i) => -i);
}

export { additiveInverseArray };
